/** 報修單狀態（DRAFT → IN_PROGRESS → COMPLETED；無 reopen、無手動完成）。 */

export const REPAIR_REQUEST_STATUS = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export const REPAIR_REQUEST_STATUS_LABELS = {
  DRAFT: '草稿',
  IN_PROGRESS: '處理中',
  COMPLETED: '處理完成',
};

export const REPAIR_REQUEST_STATUS_FILTER_OPTIONS = Object.entries(REPAIR_REQUEST_STATUS_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export function formatRepairRequestStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return REPAIR_REQUEST_STATUS_LABELS[status] ?? status;
}

/** 僅 DRAFT 可全單編輯／刪除／成立。 */
export function canEditRepairRequest(status) {
  return status === REPAIR_REQUEST_STATUS.DRAFT;
}

export function canDeleteDraftRepairRequest(status) {
  return status === REPAIR_REQUEST_STATUS.DRAFT;
}

/** 僅 DRAFT。產品預覽（含待指派 Mapping 的代號／品名）不啟用成立。 */
export function canEstablishRepairRequest(status) {
  return status === REPAIR_REQUEST_STATUS.DRAFT;
}

/** 成立後更正（表頭／品項／SN／增減品項）僅 IN_PROGRESS；完成後不可更正。 */
export function canCorrectRepairRequest(status) {
  return status === REPAIR_REQUEST_STATUS.IN_PROGRESS;
}
